export enum DecimalsSeparator {
  Comma = 1,
  Period = 2
}
